import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AvatarComponent, LinkComponent, TooltipDirective } from '@kaseya-design-components';
import { AccountTeamMember } from '@layout/account-team/models/account-team-member.interface';
import { joinNameAndSurname } from '@layout/account-team/utils/join-name-and-surname.utils';

@Component({
  selector: 'itc-account-team-panel-member',
  templateUrl: 'account-team-panel-member.component.html',
  styleUrl: 'account-team-panel-member.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent, LinkComponent, TooltipDirective, TranslatePipe],
})
export class AccountTeamPanelMemberComponent {
  readonly member = input.required<AccountTeamMember>();
  readonly roleTitleKey = input.required<string>();

  readonly fullName = computed(() => {
    const { firstName, lastName } = this.member();
    return joinNameAndSurname(firstName, lastName);
  });
}
